import axios from 'axios'
import { ConsentPayload, User, UserSubscription } from 'src/core/models'
import { UserPurchasesData } from 'src/core/models/user.types'

export async function fetchAuthenticatedUser(): Promise<User> {
  const { data } = await axios.get<User>('/api/v1/users/me/')
  return data
}

export async function fetchWidgetUsers(): Promise<{ data: object[] }> {
  const response = await axios.get('/api/v1/users/get_all_widget_users/')
  return response.data
}

export async function changeUserLanguageRequest(payload): Promise<User> {
  const response = await axios.patch('/api/v1/users/set_language/', payload)
  return response.data.user
}

export async function changeUserCurrencyAPI(payload): Promise<User> {
  const response = await axios.patch('/api/v1/users/set_currency_token/', payload)
  return response.data.user
}

export async function changeUserConsentAPI(payload: ConsentPayload): Promise<User> {
  const { data } = await axios.patch<{user: User}>('/api/v1/users/update_consent_partially/', payload)
  return data.user
}

export async function registerUserAPI(payload: any): Promise<any> {
  const { data } = await axios.post('/api/v1/big_register/?is_from_accounts=true', payload)
  return data
}

export async function existUserAPI(email: string): Promise<string> {
  const { data } = await axios.get(`/api/v1/big_register/isemail/?email=${email}`)
  return data
}

export async function validateEmailAPI(email: string, is_buyer = false): Promise<string> {
  const url = `/api/v1/big_register/validate_user_email/`
  const params = { email: email, is_buyer: is_buyer ? true : null }
  const { data } = await axios.get(url, { params })
  return data
}

export async function changePasswordAPI(payload: any): Promise<any> {
  const { data } = await axios.patch(`/api/v1/users/change_password/`, payload)
  return data
}

export async function updateUserLoginPersonalDataAPI(payload: any): Promise<User> {
  const { data } = await axios.patch(`/api/v1/users/me/`, payload)
  return data
}

export async function deleteAuthUserAPI(payload: any): Promise<any> {
  const { data } = await axios.post(`/api/v1/users/delete_user_auth_account/`, payload)
  return data
}

export async function fetchCart() {
  const response = await axios.get('/api/v1/carts')
  return response.data.results
}

export async function getUserBusinessPurchaseData(): Promise<UserPurchasesData[]> {
  const url = '/api/v1/users/business_purchases_data/'
  const { data } = await axios.get<{ user_business_purchases_data: UserPurchasesData[] }>(url)
  return data.user_business_purchases_data
}

export async function getUsersubscriptionsAPI(): Promise<UserSubscription[]> {
  const url = '/api/v1/user_subscriptions/'
  const { data } = await axios.get<UserSubscription[]>(url)
  return data
}

export async function getUserMessagesCount() {
  const response = await axios.get('/api/v1/messages/count?read=false')
  return response.data?.count || 0
}

